import { FunctionComponent } from 'react';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { FieldFormLabel, FieldLabelText } from '../FieldFormLabel/FieldFormLabel';
import { FieldTooltip } from '../FieldTooltip/FieldTooltip';
import { IFieldControlLabelContainerProps } from './FieldControlLabelContainer.interface';

const StyledFormLabel = styled(FieldFormLabel)(({ theme }) => ({
  flexShrink: 0,
  width: '40%',
  paddingRight: theme.spacing(1),
}));

export const FieldControlLabelContainer: FunctionComponent<IFieldControlLabelContainerProps> = (props) => {
  const {
    label,
    labelId,
    htmlFor,
    children,
    disabled,
    error,
    required,
    tooltip,
  } = props;

  return (
    <Stack direction={'row'}>
      <StyledFormLabel
        id={labelId}
        htmlFor={htmlFor}
        required={required && !disabled}
        error={error}
        disabled={disabled}
      >
        <FieldLabelText>
          {label}
        </FieldLabelText>
        <FieldTooltip tooltip={tooltip} />
      </StyledFormLabel>
      {children}
    </Stack>
  );
};
